import { JACKPOT_NAME_TO_SKIN } from "../../SymbolData";

/**
 * The jackpot coin: a coin whose value the math makes a jackpot is drawn as
 * `cj` with that jackpot's skin (Jp_mini … Jp_grand). The match is on the
 * server's points — options.jackpots (state.game.jackpotMultipliers) against
 * the cell's raw value. Royal is never a coin.
 *
 * @returns {string|null} the cj skin, or null for an ordinary coin
 */
const TIERS = ["mini", "minor", "midi", "major", "grand"];

export const jackpotCoinSkin = (points, jackpots) => {
  if (!jackpots || !(points > 0)) return null;
  const tier = TIERS.find((name) => jackpots[name] === points);
  return tier ? JACKPOT_NAME_TO_SKIN[tier] : null;
};
